import DiscountCoupon from '@activities/order/OrderActivity/components/Discount/DiscountCoupon';
import Accordion from '@components/Accordion';
import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import useModal from '@hooks/ui/useModal';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';
import { useMemo, useState } from 'react';

import useDiscounts from './hooks/useDiscounts';
import styles from './styles.module.scss';

function Discount() {
  const discounts = useDiscounts();
  const [coupons, setCoupons] = useState<string[]>([]);
  const { orderLines } = useCalculatedRequest();

  const [gifts, setGifts] = useState<string[]>([]);
  const { openModal, closeModal } = useModal();
  const toggleCoupon = (couponId: string) => {
    if (coupons.includes(couponId)) {
      setCoupons(coupons.filter((c) => c !== couponId));
    } else {
      if (couponId === '2' && coupons.includes('1')) {
        openModal(<Column fullWidth spacing={40}>
              <Text align='center' color={colors.gray6}>
                  장바구니 쿠폰과 상품 쿠폰을 동시에 사용할 수 없습니다.
              </Text>
            <Column fullWidth spacing={10}>
                <Button fullWidth variant='secondary' onClick={closeModal}>취소</Button>
                <Button fullWidth onClick={closeModal}>개별 쿠폰 적용</Button>
            </Column>
          </Column>);
        return;
      }
      setCoupons([...coupons, couponId]);
    }
  };
  const toggleGift = (giftId: string) => {
    if (gifts.includes(giftId)) {
      setGifts(gifts.filter((g) => g !== giftId));
    } else {
      setGifts([...gifts, giftId]);
    }
  };
  const enabledCouponCount = useMemo(() => {
    if (discounts.coupons) {
      const selectedItemIds = orderLines.map((item) => item.shopItemId);
      const filtered = discounts.coupons.filter((coupon) => {
        const { applicableItemIds } = coupon;
        if (applicableItemIds && applicableItemIds.length !== 0) {
          return selectedItemIds.filter((itemId) => applicableItemIds?.includes(itemId))?.length !== 0;
        }
        return selectedItemIds.length !== 0;
      });
      return filtered.length;
    }
    return 0;
  }, [discounts, orderLines]);
  return (
        <Accordion title={
            <Row spacing={6}>
                <Text size='lg' fontWeight='bold'>할인 적용</Text>
                <Text className={styles.info}>
                    사용 가능 쿠폰 <em>{enabledCouponCount.toLocaleString()}장</em>
                </Text>
                {/*
                <Text className={styles.info}>
                    선물 <em>{discounts?.gifts.length.toLocaleString() || 0}개</em>
                </Text> */}
            </Row>
        }>
            <Column className={styles.container}
                    spacing={18}
                    fullWidth>
                <Column fullWidth spacing={8}>
                    {(discounts.coupons?.length || 0) > 0 && (
                        <Row align='center'>
                            <Text
                                fontWeight='bold'
                                color={colors.gray7}>
                                쿠폰 적용
                            </Text>
                            {/* <Info/> */}
                        </Row>
                    )}
                    <Column className={styles.items} fullWidth spacing={12}>
                        {discounts?.coupons?.map(((c) => (
                            <DiscountCoupon coupon={c}
                                            key={c.id} />
                        )))}
                    </Column>
                </Column>
                {/*
                <Column fullWidth spacing={8}>
                    <Row align='center'>
                        <Text
                              fontWeight='bold'
                              color={colors.gray7}>
                            선물 적용
                        </Text>
                        <Info/>
                    </Row>
                    <Column className={styles.items} spacing={12} fullWidth>
                        <DiscountItem isChecked={gifts.includes('1')}
                                      onClick={() => toggleGift('1')}
                                      discountAmount={2000}
                                      expiresAt={new Date()}>
                            친구가 준 아메리카노 쿠폰
                        </DiscountItem>
                    </Column>
                </Column>
                */}
            </Column>
        </Accordion>
  );
}

export default Discount;
